import { render, staticRenderFns } from "./CustomerTrackingPage.vue?vue&type=template&id=6390b216&scoped=true&"
import script from "./CustomerTrackingPage.vue?vue&type=script&lang=js&"
export * from "./CustomerTrackingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390b216",
  null
  
)

export default component.exports